// Le titre de l'onglet — et donc le nom du fichier enregistré.
//
// « Imprimer → Enregistrer en PDF » propose comme nom de fichier le titre de
// l'onglet, espaces remplacés par des tirets bas. Une page d'impression qui
// laisse le titre de l'application envoie donc tous les devis sous le même nom.

import { useEffect } from 'react';

/** Le titre de l'application, celui de index.html. */
export const TITRE_APP = 'IMP TOITURE CRM';

/**
 * Donne ce titre à l'onglet tant que la page est affichée, et rend le
 * précédent en partant. `null` laisse le titre en place : c'est ce qu'on passe
 * pendant le chargement, quand on ne connaît pas encore le numéro de la pièce.
 */
export function useTitreDocument(titre: string | null): void {
  useEffect(() => {
    if (titre === null || titre === '') return undefined;
    const precedent = document.title;
    document.title = titre;
    return () => {
      document.title = precedent;
    };
  }, [titre]);
}
